import type { BookingDTO, BookingStatus } from '@six-pockets/shared';

export const isLive = (status: BookingStatus) => status === 'active' || status === 'paused';

/** Play time at `now`; pauses are not counted. Mirrors the server's calculation. */
export function elapsedMs(booking: BookingDTO, now: number): number {
  const running =
    booking.status === 'active' && booking.lastResumedAt ? now - new Date(booking.lastResumedAt).getTime() : 0;
  return booking.accumulatedMs + Math.max(0, running);
}

/** Ended and not yet billed: the only bookings that can be ticked for a bill. */
export const isBillable = (booking: BookingDTO) => booking.status === 'completed' && booking.billStatus === 'unbilled';
